<template>
  <quiz-layout>
    <template #sidebar>
      <div class="sidebar__menu">
        <router-link class="menu__item" :to="`/admin`">
          <div class="item__title">Lessons</div>
        </router-link>
        <router-link class="menu__item" :to="`/admin/users`">
          <div class="item__title">Users</div>
        </router-link>
        <router-link class="menu__item" :to="`/admin/rewards`">
          <div class="item__title">Rewards</div>
        </router-link>
        <router-link class="menu__item" :to="`/admin/rewards/claims`">
          <div class="item__title">Claims</div>
        </router-link>
      </div>
    </template>
    <template>
      <div class="content__title">Users</div>
      <div class="content__group">
        <b-table responsive striped hover :items="users" :fields="fields"></b-table>
      </div>
    </template>
  </quiz-layout>
</template>
<script>
import QuizLayout from "../layout/QuizLayout.vue";
import { AccountService } from "../data/services/account.service";
export default {
  components: { QuizLayout },
  data() {
    return {
      users: [],
      fields: [
        {
          key: "name",
        },
        {
          key: "email",
        },
        {
          key: "gender",
        },
        {
          key: "dob",
          label: "Birthday",
        },
        {
          key: "phone",
        },
        {
          key: "rewards",
        },
      ],
    };
  },
  mounted() {
    this.getUser();
  },
  methods: {
    async getUser() {
      const accountService = new AccountService();
      const users = await accountService.getUserList();
      this.users = users;
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  &__title {
    font-weight: 500;
    font-size: 22px;
    line-height: 25px;
    margin-bottom: 12px;
  }
  &__group {
    padding: 20px;
    width: 100%;
    background: white;
    display: flex;
    flex-direction: column;
    border-radius: 10px;
  }
}
.sidebar {
  &__menu {
    display: flex;
    flex-direction: column;
  }
}

.menu {
  &__item {
    display: flex;
    cursor: pointer;
    align-items: center;
    + .menu__item {
      margin-top: 10px;
    }
  }
}

.item {
  &__icon {
    width: 26px;
    margin-right: 15px;
    svg {
      width: 100%;
    }
  }
  &__title {
    color: #ffffff;
    //color: #f1bc04;
    font-size: 20px;
    line-height: 24px;
    &:hover {
      color: #f1bc04;
    }
  }
}
</style>
